/*global objectdetect */
var FakeCation = FakeCation || {};

(function (ns) {
  "use strict";

  function faceDetect(canvas) {
    return new Promise(function (resolve, reject) {
      setTimeout(function (c, r, e) {
        var D = objectdetect.detector,
          width = c.width,
          height = c.height,
          detector,
          treshold = width * height / 100,
          rects, candidates, selectedRect;

        detector = new D(width, height, 1.3, objectdetect.frontalface);
        rects = detector.detect(c);
        candidates = rects
          .sort(function (r1, r2) {
            return r1[2] * r1[3] - r2[2] * r2[3];
          })
          .filter(function (rect) {
            return rect[2] * rect[3] > treshold;
          });
        selectedRect = candidates.pop();

        if(selectedRect) {
          r(selectedRect);          
        } else {
          // e();
          r([0, 0, width-1, height-1]);
        }
      }, 50, canvas, resolve, reject);
    });

  }

  ns.faceDetect = faceDetect;

}(FakeCation));
